export default __webpack_public_path__ + "images/models/e9e5f84fbb3df77af677248a97fdb05a.usdz";